/**
 * Created by razial on 10.05.2025.
 */

const UniversalSlot = function (slotId) {
    this.slotId = slotId;

    this.keyOverrides = {};
    this.keysCache = {};
    this.handlers = {};

    cleverapps.dataLoader.listExistingKeys(this.storeKey("")).forEach((storageKey) => {
        this.keysCache[storageKey] = true;
    });

    if (cleverapps.config.name === "garden") {
        this.keysCache[DataLoader.TYPES.UNITS_LIBRARY + this.slotId] = true;
    }

    if (cleverapps.config.type === "merge") {
        Merge3SlotSetup(this);
    }

    Object.keys(UniversalSlot.HANDLER_FACTORIES).forEach((name) => {
        this.handlers[name] = UniversalSlot.HANDLER_FACTORIES[name](this);
    });

    Object.keys(this.keyOverrides).forEach((key) => {
        this.keysCache[this.storeKey(key)] = true;
    });
};

UniversalSlot.prototype.syncKey = function (key) {
    return UniversalSlot.keysToTable[key] || "locations";
};

UniversalSlot.prototype.storeKey = function (key) {
    const override = this.keyOverrides[key];
    if (override) {
        return override + this.slotId;
    }

    if (this.localKeyPrefix && this.isLocalKey(key)) {
        return `${this.localKeyPrefix}_${key}${this.slotId}`;
    }

    return `${DataLoader.TYPES.LOCATION + this.slotId}_${key}`;
};

UniversalSlot.prototype.isLocalKey = function (key) {
    return key.indexOf("local_") === 0;
};

UniversalSlot.prototype.addUpdateTask = function (key) {
    if (key === "all") {
        Object.keys(UniversalSlot.keysToTable).forEach((key) => this.addUpdateTask(key));
        return;
    }

    connector.synchronizer.addSendTask(this.syncKey(key) + this.slotId);
};

UniversalSlot.prototype.reset = function () {
    Object.keys(this.keysCache).forEach((storageKey) => {
        cleverapps.dataLoader.remove(storageKey);

        if (cleverapps.backwardCompatibility.has(storageKey)) {
            cleverapps.backwardCompatibility.save(storageKey);
        }
    });

    this.keysCache = {};

    this.resetStorage();

    Object.values(this.handlers).forEach((handler) => {
        if (handler.reset) {
            handler.reset();
        }
    });

    this.addUpdateTask("all");
};

UniversalSlot.prototype.load = function (key, options) {
    const handler = this.handlers[key];
    if (handler && handler.load) {
        return handler.load();
    }

    return this.loadFromStorage(key, options);
};

UniversalSlot.prototype.save = function (key, info, fromServer, options) {
    const handler = this.handlers[key];
    if (handler && handler.save) {
        handler.save(info, fromServer);
        return;
    }

    this.saveToStorage(key, info, fromServer, options);
};

UniversalSlot.prototype.loadFromStorage = function (key, options) {
    return cleverapps.dataLoader.load(this.storeKey(key), options);
};

UniversalSlot.prototype.saveToStorage = function (key, info, fromServer, options) {
    const storageKey = this.storeKey(key);

    if (cleverapps.isEmpty(info)) {
        cleverapps.dataLoader.remove(storageKey, options);
        delete this.keysCache[storageKey];
    } else {
        cleverapps.dataLoader.save(storageKey, info, options);
        this.keysCache[storageKey] = true;
    }

    if (cleverapps.backwardCompatibility.has(storageKey)) {
        cleverapps.backwardCompatibility.save(storageKey, fromServer);
    }

    if (!fromServer && !this.isLocalKey(key)) {
        this.addUpdateTask(key);
    }
};

UniversalSlot.prototype.resetStorage = function () {
};

UniversalSlot.prototype.remove = function (key, fromServer, options) {
    this.save(key, undefined, fromServer, options);
};

UniversalSlot.prototype.updateLocationInfo = function (serverData) {
    Object.keys(this.keysCache).forEach((storageKey) => {
        cleverapps.dataLoader.remove(storageKey);
    });

    this.keysCache = {};

    Object.keys(serverData).forEach((key) => {
        const storageKey = this.storeKey(key);

        this.keysCache[storageKey] = true;

        cleverapps.dataLoader.save(storageKey, serverData[key]);
    });
};

UniversalSlot.prototype.getLocationInfo = function () {
    const serverData = {};

    const prefix = this.storeKey("");

    Object.keys(this.keysCache).forEach((storageKey) => {
        const key = storageKey.replace(prefix, "");

        if (key === storageKey || this.isLocalKey(key) || this.syncKey(key) !== "locations") {
            return;
        }

        const value = cleverapps.dataLoader.load(storageKey);

        if (!cleverapps.isEmpty(value)) {
            serverData[key] = value;
        }
    });

    return serverData;
};

UniversalSlot.HANDLER_FACTORIES = {};

UniversalSlot.keysToTable = {};

UniversalSlot.registerTable = function (table, adapter) {
    UniversalSlot.keysToTable[table] = table;

    SyncAdapters.registerBySlots(table, {
        getInfo: (slotId) => adapter.getInfo(cleverapps.dataSlots.getSlot(slotId)),
        updateInfo: (slotId, serverData) => adapter.updateInfo(cleverapps.dataSlots.getSlot(slotId), serverData),
        order: -1
    });
};

UniversalSlot.registerTable("locations", {
    getInfo: (slot) => slot.getLocationInfo(),
    updateInfo: (slot, serverData) => slot.updateLocationInfo(serverData)
});
